import React from "react";
import Lottie from "react-lottie";
// import animationData from "../../Assets/animations/data.json";
import './Loader.css'
const Loader = () => {
 
  return (
    <div className="w-screen h-screen flex justify-center items-center">
         <div class="loader"></div>
    </div>

    
  );
};

export default Loader;
